"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyScheduleControlInteractor = void 0;
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
const CommonScheduleControlInteractor_1 = require("../../CommonScheduleControlInteractor");
const DailyScheduleHarmonizationManager_1 = require("../../DailyScheduleHarmonizationManager");
const helpers_1 = require("../../helpers");
require("../../models");
const types_1 = require("../../types");
class DailyScheduleControlInteractor extends CommonScheduleControlInteractor_1.CommonScheduleControlInteractor {
    constructor(controlModel, texts, retentionFieldsSettings, models, listener, handlers, columns = helpers_1.getDailyColumns()) {
        super(controlModel, texts, columns);
        this.controlModel = controlModel;
        this.texts = texts;
        this.retentionFieldsSettings = retentionFieldsSettings;
        this.models = models;
        this.listener = listener;
        this.handlers = handlers;
        this.columns = columns;
        this.subscriptions = new rxjs_1.Subscription();
        this.handleDone = () => {
            if (!this.form.validateAndDisplayErrors()) {
                return;
            }
            this.handlers.onDone(this.controlModel.getValue());
        };
        this.handleCancel = () => {
            if (this.form.hasChanges()) {
                this.handlers.onCancel();
                return;
            }
            this.handlers.onClose();
        };
        this.willDeactivate = () => __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.unsubscribe();
        });
        this.onRepositoriesDialogShow = () => {
            this.listener.onSnapshotsPerHourDialogActivate({
                initialValue: this.controlModel.getValue().fieldRunsPerHourValue,
                onDone: (count) => {
                    this.form.model.update((value) => {
                        value.fieldRunsPerHourValue = count;
                    });
                },
                rowName: this.texts.rowFirstTitlePlural,
            });
        };
        this.getRows = () => {
            return helpers_1.getDailyScheduleRows(this.controlModel.getValue(), this.texts, this.getScheduleRowsVisibilityData(), this.onRepositoriesDialogShow);
        };
        this.getFieldKindOptions = () => {
            return helpers_1.getTextOptionsList(helpers_1.getDailyKindList(), this.texts);
        };
        this.getFieldDaysOfWeekOptions = () => {
            return helpers_1.getTextOptionsList(helpers_1.getDaysOfWeekList(), this.texts);
        };
        this.isFieldDaysVisible = () => {
            return this.controlModel.isFieldKindSelectedDays();
        };
        this.listener = listener;
        this.texts = texts;
        this.handlers = handlers;
        this.harmonizationManager = new DailyScheduleHarmonizationManager_1.DailyScheduleHarmonizationManager(models.dailyScheduleModel, controlModel, models, retentionFieldsSettings);
        this.form = new core_1.Form(this.controlModel, {
            validationSchema: Object.assign(Object.assign({}, CommonScheduleControlInteractor_1.CommonScheduleControlInteractor.getScheduleRowsValidations(this.texts.errorTextFirstScheduleIsRequired, models.dailyScheduleModel.isSecondRowExistingAndEnabled(), models.dailyScheduleModel.isThirdRowExistingAndEnabled(), retentionFieldsSettings.rowFirstFieldCountMin, retentionFieldsSettings.rowFirstFieldCountMax, retentionFieldsSettings.rowSecondFieldCountMin, retentionFieldsSettings.rowSecondFieldCountMax, retentionFieldsSettings.rowThirdFieldCountMin, retentionFieldsSettings.rowThirdFieldCountMax)), { fieldDaysValue: [
                    core_1.conditions({
                        fieldKindValue: types_1.DAILY_SCHEDULE_KINDS.selectedDays,
                    }, core_1.required()),
                ], fieldKindValue: [core_1.required()] }),
        });
        this.dailyScheduleKindComboboxModel = new core_1.Model(this.getFieldKindOptions());
        this.dailyScheduleDaysComboboxModel = new core_1.Model(this.getFieldDaysOfWeekOptions());
        this.scheduleRetentionTypeComboboxModel = new core_1.Model(this.getScheduleRetentionTypeOptions());
        this.scheduleMatrixLegendFooter = components_1.createSchedulingMatrixLegendFooter({
            texts: {
                label: this.texts.matrixFooterSelectModeLabel,
                selectMode: this.texts.matrixFooterSelectModeSelectLabel,
                unselectMode: this.texts.matrixFooterSelectModeUnselectLabel,
            },
        });
    }
}
exports.DailyScheduleControlInteractor = DailyScheduleControlInteractor;
//# sourceMappingURL=DailyScheduleControlInteractor.js.map